/**
 * @generated SignedSource<<9920faa37a7dcb8bc1adec4a9d64faa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertGCPIntegrationInput = {
  accessConfig?: GCPIntegrationAccessConfigInput | null | undefined;
  accessConfigBlob?: string | null | undefined;
  customerConfig?: GCPIntegrationCustomerConfigInput | null | undefined;
  key: string;
};
export type GCPIntegrationCustomerConfigInput = {
  costSources?: ReadonlyArray<GCPIntegrationCustomerCostSourceInput> | null | undefined;
  infrastructure?: GCPIntegrationCustomerInfrastructureInput | null | undefined;
  organizations?: ReadonlyArray<GCPIntegrationCustomerOrganizationInput> | null | undefined;
  securityContexts?: ReadonlyArray<GCPIntegrationCustomerSecurityContextInput> | null | undefined;
};
export type GCPIntegrationCustomerInfrastructureInput = {
  createProject?: GCPIntegrationCustomerCreateProjectInput | null | undefined;
  projectId?: string | null | undefined;
  resourceLocation?: string | null | undefined;
  resourcePrefix?: string | null | undefined;
};
export type GCPIntegrationCustomerCreateProjectInput = {
  billingAccountId?: string | null | undefined;
  folderId?: string | null | undefined;
  labels?: ReadonlyArray<TagInput> | null | undefined;
  orgId?: string | null | undefined;
};
export type TagInput = {
  key: string;
  value?: string | null | undefined;
};
export type GCPIntegrationCustomerOrganizationInput = {
  folderIds: ReadonlyArray<string>;
  orgId: string;
  projectIds: ReadonlyArray<string>;
};
export type GCPIntegrationCustomerCostSourceInput = {
  billingTable: string;
};
export type GCPIntegrationCustomerSecurityContextInput = {
  extraRoles: ReadonlyArray<string>;
  name: string;
};
export type GCPIntegrationAccessConfigInput = {
  costSources: ReadonlyArray<GCPIntegrationAccessCostSourceInput>;
  infrastructure: GCPIntegrationAccessInfrastructureInput;
  organizations: ReadonlyArray<GCPIntegrationAccessOrganizationInput>;
  roundtripDigest: string;
  securityContexts: ReadonlyArray<GCPIntegrationAccessSecurityContextInput>;
};
export type GCPIntegrationAccessInfrastructureInput = {
  baselineRoles: ReadonlyArray<string>;
  projectId: string;
  relay: GCPIntegrationAccessRelayInput;
  wif: GCPIntegrationAccessWIFInput;
};
export type GCPIntegrationAccessRelayInput = {
  oauthId: string;
};
export type GCPIntegrationAccessWIFInput = {
  audience: string;
  principals: GCPIntegrationAccessWIFPrincipalsInput;
};
export type GCPIntegrationAccessWIFPrincipalsInput = {
  costQuery: string;
  readOnly: string;
};
export type GCPIntegrationAccessOrganizationInput = {
  folders: ReadonlyArray<GCPIntegrationAccessOrganizationFolderInput>;
  id: string;
  name: string;
  projects: ReadonlyArray<GCPIntegrationAccessOrganizationProjectInput>;
};
export type GCPIntegrationAccessOrganizationFolderInput = {
  id: string;
  name: string;
};
export type GCPIntegrationAccessOrganizationProjectInput = {
  id: string;
  number: string;
};
export type GCPIntegrationAccessCostSourceInput = {
  billingTable: string;
  location: string;
};
export type GCPIntegrationAccessSecurityContextInput = {
  extraRoles: ReadonlyArray<string>;
  name: string;
  principal: string;
};
export type UpsertGCPIntegrationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: UpsertGCPIntegrationInput;
};
export type UpsertGCPIntegrationMutation$data = {
  readonly upsertGCPIntegration: {
    readonly gcpIntegration: {
      readonly accessConfig: {
        readonly costSources: ReadonlyArray<{
          readonly billingTable: string;
        }>;
        readonly infrastructure: {
          readonly projectId: string;
        };
        readonly organizations: ReadonlyArray<{
          readonly folders: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
          readonly name: string;
          readonly projects: ReadonlyArray<{
            readonly id: string;
          }>;
        }>;
        readonly roundtripDigest: string;
        readonly securityContexts: ReadonlyArray<{
          readonly extraRoles: ReadonlyArray<string>;
          readonly name: string;
        }>;
      } | null | undefined;
      readonly customerConfig: {
        readonly costSources: ReadonlyArray<{
          readonly billingTable: string;
        }>;
        readonly infrastructure: {
          readonly createProject: {
            readonly billingAccountId: string;
            readonly folderId: string | null | undefined;
            readonly labels: ReadonlyArray<{
              readonly key: string;
              readonly value: string | null | undefined;
            }>;
            readonly orgId: string | null | undefined;
          } | null | undefined;
          readonly projectId: string;
          readonly resourceLocation: string;
          readonly resourcePrefix: string;
        } | null | undefined;
        readonly organizations: ReadonlyArray<{
          readonly folderIds: ReadonlyArray<string>;
          readonly orgId: string;
          readonly projectIds: ReadonlyArray<string>;
        }>;
        readonly securityContexts: ReadonlyArray<{
          readonly extraRoles: ReadonlyArray<string>;
          readonly name: string;
        }>;
        readonly terraformModule: {
          readonly blockHCL: string;
          readonly roundtripDigest: string;
        } | null | undefined;
      };
      readonly key: string;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
};
export type UpsertGCPIntegrationMutation = {
  response: UpsertGCPIntegrationMutation$data;
  variables: UpsertGCPIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "extraRoles",
    "storageKey": null
  }
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billingTable",
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundtripDigest",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "GCPIntegrationCustomerConfig",
  "kind": "LinkedField",
  "name": "customerConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerOrganization",
      "kind": "LinkedField",
      "name": "organizations",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "folderIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerSecurityContext",
      "kind": "LinkedField",
      "name": "securityContexts",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerCostSource",
      "kind": "LinkedField",
      "name": "costSources",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationCustomerInfrastructure",
      "kind": "LinkedField",
      "name": "infrastructure",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resourceLocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resourcePrefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationCustomerCreateProject",
          "kind": "LinkedField",
          "name": "createProject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billingAccountId",
              "storageKey": null
            },
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "folderId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Tag",
              "kind": "LinkedField",
              "name": "labels",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TerraformModule",
      "kind": "LinkedField",
      "name": "terraformModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockHCL",
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GCPIntegrationAccessConfig",
  "kind": "LinkedField",
  "name": "accessConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessInfrastructure",
      "kind": "LinkedField",
      "name": "infrastructure",
      "plural": false,
      "selections": [
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessOrganization",
      "kind": "LinkedField",
      "name": "organizations",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationAccessOrganizationFolder",
          "kind": "LinkedField",
          "name": "folders",
          "plural": true,
          "selections": (v12/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GCPIntegrationAccessOrganizationProject",
          "kind": "LinkedField",
          "name": "projects",
          "plural": true,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessCostSource",
      "kind": "LinkedField",
      "name": "costSources",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GCPIntegrationAccessSecurityContext",
      "kind": "LinkedField",
      "name": "securityContexts",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpsertGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GCPIntegration",
            "kind": "LinkedField",
            "name": "gcpIntegration",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpsertGCPIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpsertGCPIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertGCPIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GCPIntegration",
            "kind": "LinkedField",
            "name": "gcpIntegration",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v10/*: any*/),
              (v13/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "gcpIntegration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "GCPIntegrationEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isProblem"
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f94719f282d70aba4c29595241bbc389",
    "id": null,
    "metadata": {},
    "name": "UpsertGCPIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertGCPIntegrationMutation(\n  $input: UpsertGCPIntegrationInput!\n) {\n  upsertGCPIntegration(input: $input) {\n    gcpIntegration {\n      key\n      customerConfig {\n        organizations {\n          orgId\n          folderIds\n          projectIds\n        }\n        securityContexts {\n          name\n          extraRoles\n        }\n        costSources {\n          billingTable\n        }\n        infrastructure {\n          projectId\n          resourceLocation\n          resourcePrefix\n          createProject {\n            billingAccountId\n            orgId\n            folderId\n            labels {\n              key\n              value\n            }\n          }\n        }\n        terraformModule {\n          blockHCL\n          roundtripDigest\n        }\n      }\n      accessConfig {\n        infrastructure {\n          projectId\n        }\n        organizations {\n          id\n          name\n          folders {\n            id\n          }\n          projects {\n            id\n          }\n        }\n        costSources {\n          billingTable\n        }\n        securityContexts {\n          name\n          extraRoles\n        }\n        roundtripDigest\n      }\n      id\n    }\n    problems {\n      __typename\n      __isProblem: __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41445387007dc520b9c2eae849347f51";

export default node;
